// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {getVsrMessage, hasVsrErrorForClaimField} from '../../../../shared/services/claim-shared-helper';
import ClaimMassChannelCustomerFollowup from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-customer-followup';
import FormValidation from '../../state/form-validation';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledDateInput from '../../../../shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../../shared/components/claim-fields/labeled-input';
import LabeledInputWithBlur from '../../../../shared/components/claim-fields/labeled-input-with-blur';
import LabeledKeyValueDropDown from '../../../../shared/components/claim-fields/labeled-key-value-dropdown';
import {buildDealer} from '../../../../../shared/services/build-dealer';
import moment from 'moment';

function handleInputBlur(property, value) {

    this.actions.updateFormValidation(property, value);

}

function handleWorkOrderOneChange(workOrderOne) {

    this.actions.updateWorkOrderOne(workOrderOne);

}

function handleWorkOrderTwoChange(workOrderTwo) {

    this.actions.updateWorkOrderTwo(workOrderTwo);

}

function handleGoodsInstallationVatChange(event) {

    this.actions.updateGoodsInstallationVat(event.target.value, this.goodsInstallationVatOptions);

}

function handleDropDownBlur(property, event) {

    this.actions.updateFormValidation(property, event.target.value);

}

function handleMethodOfContactChange(event) {

    this.actions.updateMethodOfContact(event.target.value, this.methodOfContactOptions);

}

function handleContactDateChange(date) {

    this.actions.updateContactDate(date);

}

function handleRelationshipChange(event) {

    this.actions.updateRelationship(event.target.value, this.relationshipOptions);

}

function handleFirstNameChange(firstName) {

    this.actions.updateFirstName(firstName);

}

function handleLastNameChange(lastName) {

    this.actions.updateLastName(lastName);

}

function handleEMailChange(eMail) {

    this.actions.updateEMail(eMail);

}

const ProductInformationContainer = props =>
    <section className='product-information-container'>
        <h3>
            <FormattedMessage id='PRODUCT_INFORMATION'/>
        </h3>
        <div className='product-info'>
            <LabeledInput
                className='dealer-location'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'dealerLocation', props.isEditable)}
                isEditable={false}
                label='DEALER_LOCATION'
                value={buildDealer(props.claim.responsibleAccount)}
                vsrMessage={getVsrMessage(props.claim.errors, 'dealerLocation', props.isEditable)}
            />
            <LabeledInput
                className='pin'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'pin', props.isEditable)}
                isEditable={false}
                label='PIN'
                value={props.claim.pin}
                vsrMessage={getVsrMessage(props.claim.errors, 'pin', props.isEditable)}
            />
        </div>
        <h3>
            <FormattedMessage id='REFERENCE_INFORMATION'/>
        </h3>
        <div className='reference-info'>
            <LabeledInputWithBlur
                className='work-order-one'
                errorMessage='WORK_ORDER_ONE_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'workOrderOne', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.referenceNumber1}
                label='WORK_ORDER_ONE'
                maxLength={40}
                onBlur={handleInputBlur.bind(props, 'referenceNumber1')}
                onChange={props::handleWorkOrderOneChange}
                value={props.claim.referenceInfo.referenceNumber1}
                vsrMessage={getVsrMessage(props.claim.errors, 'workOrderOne', props.isEditable)}
            />
            <LabeledInput
                className='work-order-two'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'workOrderTwo', props.isEditable)}
                isEditable={props.isEditable}
                label='WORK_ORDER_TWO'
                maxLength={12}
                onChange={props::handleWorkOrderTwoChange}
                value={props.claim.referenceInfo.referenceNumber2}
                vsrMessage={getVsrMessage(props.claim.errors, 'workOrderTwo', props.isEditable)}
            />
            {props.claim.showGoodsInstallationVat &&
                <LabeledKeyValueDropDown
                    className='goods-installation-vat'
                    errorMessage='GOODS_INSTALLATION_VAT_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'goodsInstallationVat', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={true}
                    label='GOODS_INSTALLATION_VAT'
                    list={props.goodsInstallationVatOptions}
                    onChange={props::handleGoodsInstallationVatChange}
                    selectedValue={props.claim.goodsInstallationVat}
                    vsrMessage={getVsrMessage(props.claim.errors, 'goodsInstallationVat', props.isEditable)}
                />
            }
        </div>
        <h3>
            <FormattedMessage id='RESPONDENT_INFORMATION'/>
        </h3>
        <div className='respondent-info'>
            <LabeledKeyValueDropDown
                className='method-of-contact'
                errorMessage='METHOD_OF_CONTACT_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'methodOfContact', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.methodOfContact}
                label='METHOD_OF_CONTACT'
                list={props.methodOfContactOptions}
                onBlur={handleDropDownBlur.bind(props, 'methodOfContact')}
                onChange={props::handleMethodOfContactChange}
                selectedValue={props.claim.methodOfContact}
                vsrMessage={getVsrMessage(props.claim.errors, 'methodOfContact', props.isEditable)}
            />
            <LabeledDateInput
                className='contacted-date'
                date={props.claim.contactDate}
                errorMessage='CONTACTED_DATE_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'contactDate', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.contactDate}
                label='CONTACTED'
                maxDate={moment()}
                onBlur={handleInputBlur.bind(props, 'contactDate')}
                onDateChange={props::handleContactDateChange}
                vsrMessage={getVsrMessage(props.claim.errors, 'contactDate', props.isEditable)}
            />
            <LabeledKeyValueDropDown
                className='relationship'
                errorMessage='RELATIONSHIP_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'relationship', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.relationship}
                label='RELATIONSHIP'
                list={props.relationshipOptions}
                onBlur={handleDropDownBlur.bind(props, 'relationship')}
                onChange={props::handleRelationshipChange}
                selectedValue={props.claim.relationship}
                vsrMessage={getVsrMessage(props.claim.errors, 'relationship', props.isEditable)}
            />
        </div>
        <div className='respondent-info'>
            <LabeledInputWithBlur
                className='first-name'
                errorMessage='FIRST_NAME_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'firstName', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.firstName}
                label='FIRST_NAME'
                maxLength={70}
                onBlur={handleInputBlur.bind(props, 'firstName')}
                onChange={props::handleFirstNameChange}
                value={props.claim.customerDetails.firstName}
                vsrMessage={getVsrMessage(props.claim.errors, 'firstName', props.isEditable)}
            />
            <LabeledInputWithBlur
                className='last-name'
                errorMessage='LAST_NAME_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'lastName', props.isEditable)}
                isEditable={props.isEditable}
                isValid={props.formValidation.lastName}
                label='LAST_NAME'
                maxLength={70}
                onBlur={handleInputBlur.bind(props, 'lastName')}
                onChange={props::handleLastNameChange}
                value={props.claim.customerDetails.lastName}
                vsrMessage={getVsrMessage(props.claim.errors, 'lastName', props.isEditable)}
            />
            <LabeledInput
                className='email'
                highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'email', props.isEditable)}
                isEditable={props.isEditable}
                label='EMAIL'
                maxLength={241}
                onChange={props::handleEMailChange}
                type='email'
                value={props.claim.customerDetails.email}
                vsrMessage={getVsrMessage(props.claim.errors, 'email', props.isEditable)}
            />
        </div>
    </section>;

ProductInformationContainer.displayName = 'ProductInformationContainer';
ProductInformationContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(ClaimMassChannelCustomerFollowup).isRequired,
    formValidation: PropTypes.instanceOf(FormValidation).isRequired,
    goodsInstallationVatOptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    isEditable: PropTypes.bool.isRequired,
    methodOfContactOptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    relationshipOptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default ProductInformationContainer;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/product-information/product-information-container.js